import React from 'react';
import PropTypes from 'prop-types';
import ImageUpload from './ImageUpload';
import DiagramImageSelect from './DiagramImageSelect';

const ImageUploadOrDiagramSelect = ({ image, onImageChange, onDiagramChange, name, error }) => {
  let heroImageContainerClass = '';
  if (image.src) {
    heroImageContainerClass = 'image-added';
    if (image.type === 'pitch-diagram-snapshot-image') {
      heroImageContainerClass = 'image-added diagram-added';
    }
  }

  return (
    <div className={`main-diagram-image-options ${heroImageContainerClass}`}>
      <ImageUpload
        name={name || 'image'}
        value={image}
        onChange={onImageChange}
        error={error}
      />

      <DiagramImageSelect
        name={name || 'diagram-image'}
        value={image}
        onChange={onDiagramChange}
        error={error}
      />
    </div>
  );
};

ImageUploadOrDiagramSelect.propTypes = {
  image: PropTypes.object,
  onImageChange: PropTypes.func.isRequired,
  onDiagramChange: PropTypes.func.isRequired,
  name: PropTypes.string,
  error: PropTypes.object,
};

export default ImageUploadOrDiagramSelect;



// WEBPACK FOOTER //
// ./library/app/components/Global/Forms/ImageUploadOrDiagramSelect.js